import { nullishFilter, arrayToObj } from '@caresend/utils';
import { hasMutation, customCommit } from '../helpers.js';

const setOffices = (
/** Optional mutations require type casting */
commit, orderDataArray, store) => {
    let officesSet = 'N/A';
    let offices = {};
    if (hasMutation(store, 'offices/SET_OFFICES')) {
        // Office data is not returned on order yet, doing this to be ready.
        const officesArray = orderDataArray.map((orderDataPoint) => orderDataPoint.officeData).filter(nullishFilter);
        offices = arrayToObj(officesArray, 'id');
        // Count after conversion to obj to remove duplicates
        officesSet = Object.keys(offices).length;
        customCommit(commit, 'offices/SET_OFFICES', offices);
    }
    return { officesSet, offices };
};
const setOfficeLocalOrderID = (
/** Optional mutations require type casting */
commit, data, store) => {
    if (hasMutation(store, 'office/SET_LOCAL_ORDER_ID')) {
        customCommit(commit, 'office/SET_LOCAL_ORDER_ID', data);
    }
};

export { setOfficeLocalOrderID, setOffices };
